// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2PDQx","img":"Header_img__qVwVh","five":"Header_five__2Uu6i"};